import axios from 'axios'
import _ from 'lodash'

export default {
  namespaced: true,

  state: {
    services: [],
    service: {},
    pagination: {},
    page: 1,
    loading: false,
    creating: false
  },
  mutations: {
    set(state, services) {
      state.services = _.unionBy(state.services, services, 'id')
    },
    change(state, item) {
      if (typeof item === 'object') {
        state.services = state.services.map(service => {
          if (service.id === item.id) {
            return Object.assign(service, item)
          } else {
            return service
          }
        })
      } else if (typeof item === 'number') {
        const position = state.services.findIndex(sh => sh.id === item)
        state.services.splice(position, 1)
        state.pagination.total--
      }
    },
    setService(state, service) {
      state.service = service
    },
    pagination(state, pagination) {
      state.pagination = pagination
    },
    reset(state) {
      state.services = []
      state.page = 1
    },
    changePage(state, page) {
      if (page) {
        state.page = page
      } else {
        state.page++
      }
    },
    setLoading(state, loading) {
      state.loading = loading
    },
    setCreating(state, creating) {
      state.creating = creating
    }
  },
  actions: {
    async fetch({commit, getters, state}) {
      if (state.loading) return
      commit('setLoading', true)
      let page = getters.page
      try {
        const url = process.env.VUE_APP_BACKEND
        const services = await axios.get(url + '/services/', {
          params: {page}
        })
        commit('pagination', services.data.pagination)
        commit('set', services.data.services)
        commit('changePage')
      } catch (e) {
        commit('setError', e, {root: true})
        throw e
      } finally {
        commit('setLoading', false)
      }
    },
    async create({commit, dispatch, state}, service) {
      if (state.creating) return
      commit('setCreating', true)
      try {
        const url = process.env.VUE_APP_BACKEND
        await axios.post(url + '/services', service)
        commit('reset')
        await dispatch('fetch')
      } catch (e) {
        commit('setError', e, {root: true})
        throw e
      } finally {
        commit('setCreating', false)
      }
    },
    async update({commit, dispatch, state}, service) {
      if (state.creating) return
      commit('setCreating', true)
      const id = service.id
      delete service.id
      try {
        const url = process.env.VUE_APP_BACKEND
        await axios.put(url + '/services/' + id, service)
        commit('reset')
        await dispatch('fetch')
      } catch (e) {
        commit('setError', e, {root: true})
        throw e
      } finally {
        commit('setCreating', false)
      }
    },
    async activate({commit}, id) {
      try {
        const url = process.env.VUE_APP_BACKEND
        await axios.patch(url + '/services/' + id + '/activate')
      } catch (e) {
        commit('setError', e, {root: true})
        throw e
      }
    },
    async deactivate({commit}, id) {
      try {
        const url = process.env.VUE_APP_BACKEND
        await axios.patch(url + '/services/' + id + '/deactivate')
      } catch (e) {
        commit('setError', e, {root: true})
        throw e
      }
    },
    async delete({commit}, id) {
      try {
        const url = process.env.VUE_APP_BACKEND
        await axios.delete(url + '/services/' + id)
      } catch (e) {
        commit('setError', e, {root: true})
        throw e
      }
    },
    async checkOrphaned({commit}) {
      try {
        const url = process.env.VUE_APP_BACKEND
        const response = await axios.get(url + '/services/orphaned/check')
        return response.data
      } catch (e) {
        commit('setError', e, {root: true})
        throw e
      }
    },
    async listAllServices({commit}) {
      try {
        const url = process.env.VUE_APP_BACKEND
        const response = await axios.get(url + '/services/orphaned/list')
        return response.data.services
      } catch (e) {
        commit('setError', e, {root: true})
        throw e
      }
    },
    async claimOrphaned({commit, dispatch}) {
      try {
        const url = process.env.VUE_APP_BACKEND
        const response = await axios.post(url + '/services/orphaned/claim')
        commit('reset')
        await dispatch('fetch')
        return response.data
      } catch (e) {
        commit('setError', e, {root: true})
        throw e
      }
    },
    async claimSelected({commit, dispatch}, serviceIds) {
      try {
        const url = process.env.VUE_APP_BACKEND
        const response = await axios.post(url + '/services/orphaned/claim-selected', {serviceIds})
        commit('reset')
        await dispatch('fetch')
        return response.data
      } catch (e) {
        commit('setError', e, {root: true})
        throw e
      }
    },
    async reassign({commit, dispatch}, {serviceIds, toCompanyID}) {
      try {
        const url = process.env.VUE_APP_BACKEND
        const response = await axios.post(url + '/services/reassign', {serviceIds, toCompanyID})
        commit('reset')
        await dispatch('fetch')
        return response.data
      } catch (e) {
        commit('setError', e, {root: true})
        throw e
      }
    }
  },
  getters: {
    services: s => s.services,
    service: s => s.service,
    pagination: s => s.pagination,
    page: s => s.page,
    creating: s => s.creating,
    loading: s => s.loading
  }
}
